<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <footer v-if="isPartnerView" class="the-footer flex-wrap justify-between" :class="classes">
        <span>© {{ new Date().getFullYear() }} Radix FZC. All Rights Reserved</span>
    </footer>

    <footer v-else class="the-footer flex-wrap justify-center text-center" :class="classes">
        <span>If you have any questions or require any support regarding your rebates, please reach out to: <br>Rebates Team: <a href="mailto:falcon@radix.email">falcon@radix.email</a> <br><span v-if="clientAMName">Account Manager: {{ clientAMName }} - <a :href="`mailto:${clientAMEmail}`">{{ clientAMEmail }}</a></span></span>
    </footer>
    
</template>

<script>
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        }
    },
    computed: {
        isPartnerView() {
            localStorage.getItem('isPartnerView')
        },
        clientAMName() {
            return this.$store.state.clientAMName;
        },
        clientAMEmail() {
            return this.$store.state.clientAMEmail;
        }
    },
}
</script>
